var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 0H0V30H45V0Z",
    fill: "#E2E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3111 3C13.0347 3 12 4.03472 12 5.31111V24.6889C12 25.9653 13.0347 27 14.3111 27H30.8444C32.1208 27 33.1556 25.9653 33.1556 24.6889V18.3778V9.75556V9.75506L26.5783 3H26.5778H14.3111Z",
    fill: "#EC3333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5781 3L29.867 6.37778L33.1559 9.75556H28.8892C27.6128 9.75556 26.5781 8.72084 26.5781 7.44444V3Z",
    fill: "#B10101"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.515 13.2019V14.1148H26.7412V15.3999H29.0866V16.3127H26.7412V18.5247H25.6738V13.2019H29.515Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5126 17.5978C23.5027 17.5978 24.1207 16.9307 24.1207 15.8633C24.1207 14.7959 23.5027 14.1288 22.5126 14.1288L21.6699 14.1359V17.5908L22.5126 17.5978ZM20.6025 18.5247V13.2019H22.5337C24.0926 13.2019 25.1881 14.2974 25.1881 15.8633C25.1881 17.4293 24.0926 18.5247 22.5337 18.5247H20.6025Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3416 16.0108C18.8472 16.0108 19.1632 15.6456 19.1632 15.0628C19.1632 14.4799 18.8472 14.1148 18.3416 14.1148H17.0986V16.0108H18.3416ZM16.0312 18.5247V13.2019H18.3767C19.4651 13.2019 20.2305 13.9673 20.2305 15.0628C20.2305 16.1583 19.4651 16.9237 18.3767 16.9237H17.0986V18.5247H16.0312Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon_pdf.102248a7df70b75bdd2006fa77091464.svg";
export { ForwardRef as ReactComponent };